<!-- 社员投稿 -->
<template>
  <div id="Mzsm">
    <headerVue></headerVue>
    <div class="container">
      <div class="title">社员投稿</div>
      <!-- 循环 -->
      <div class="content">
        <el-form ref="form" :model="form" label-width="120px">
          <div style="display: flex;">
            <el-form-item label="投稿人" style="flex: 1;">
              <el-input v-model="form.tname"></el-input>
            </el-form-item>
            <el-form-item label="投稿人电话" style="flex: 1;margin-left: 20px;">
              <el-input v-model="form.tphone"></el-input>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item label="投稿时间" style="flex: 1;">
              <el-date-picker type="date" placeholder="选择日期" v-model="form.tdate"></el-date-picker>
            </el-form-item>
            <el-form-item label="标题" style="flex: 1;margin-left: 20px;">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="内容">
            <!-- <el-input type="textarea" v-model="form.tcontent" style="margin-left: 30px;"></el-input> -->
            <!-- 富文本框 -->
            <Editor class="editor" style="height: 200px;width: 580px"></Editor>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="primary" @click="submit"
              style="width: 200px;margin-left: 200px;margin-top: 80px;">提交</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>
    <footerVue></footerVue>
  </div>
</template>

<script>
import Editor from '../Editor.vue'

import headerVue from '../index/header.vue'
import footerVue from '../foot/foot.vue'

export default {
  name: 'Sytg',
  data() {
    return {
      form: {
        tname: '',
        tphone: '',
        tdate: '',
        tcontent: '',
        title: ''
      }
    }
  },
  created() {

  },
  methods: {

  },
  components: {
    headerVue,
    footerVue,
    Editor
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: auto;
  background-color: white;
  margin-top: 20px;

  .title {
    padding: 10px;
    padding-bottom: 20px;
    font-size: 20px;
    text-align: center;
    letter-spacing: 1px;
  }

  .content {
    // text-indent: 2em;
    color: #4D4F53;
    line-height: 60px;
    padding: 10px;
    width: 60%;
    margin-left: 160px;
    // margin: auto;
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .container {
    width: 100%;

    .content {
      margin-left: 10px;
      width: 80%;

      // background-color: pink;
      .btn {
        margin-left: 30% !important;
      }
      .editor{
        width: 100%;
      }
    }
  }
}

::v-deep .el-icon-date:before {
  content: ''
}
</style>